import { useEffect, useRef } from 'react';

const useEscapeClose = (handlers) => {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        for (const handler of handlersRef.current) {
          // [isOpen, close] tuple formatı veya { state, setter } obje formatı
          const isOpen = Array.isArray(handler) ? handler[0] : handler.state;
          const close = Array.isArray(handler) ? handler[1] : () => handler.setter(false);
          if (isOpen) {
            close();
            return;
          }
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
};

export default useEscapeClose;
